import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {ConclusoesFichasModel} from "./conclusoes-fichas.model";
import {ConclusoesFichasService} from "./conclusoes-fichas.service";


@Component({
  selector: 'app-conclusoes-fichas-form',
  templateUrl: './conclusoes-fichas-form.component.html'
})
export class ConclusoesFichasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  conclusao: ConclusoesFichasModel = new ConclusoesFichasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private conclusoesFichasService: ConclusoesFichasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_conclusao: [],
      conclusao_pt: ['', [
        Validators.required
      ]],
      conclusao_en: ['', [
        Validators.required
      ]],
      conclusao_es: ['', [
        Validators.required
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_conclusao'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarConclusao');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarConclusao') : this.func.traduzir('front.cadastrarNovaConclusao');
      }

      if (!id) {
        return;
      }

      this.conclusoesFichasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarConclusao')+': '+json.Payload[0].conclusao_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarConclusao') + ': ' + json.Payload[0].conclusao_pt;
            }
            this.conclusao = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id_conclusao) {
      result = this.conclusoesFichasService.editar(values, values.id_conclusao);
    } else {
      result = this.conclusoesFichasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'conclusoes']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/conclusoes-fichas/conclusoes-fichas-form.component.ts